module.exports = __webpack_public_path__ + "img/ar06.653d4491.jpg";